import React from 'react';
import {
  DeleteOutlined,
  GlobalOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { Button, Col, Input, Form, Row, InputRef } from 'antd';

import { inputMaskHash } from 'constants/masks';

import {
  defaultContactNames,
  DefaultContactOptionsTypes,
} from './ContactsSelector';
import { CustomIcon, SvgIconNames } from '../../icons/icons';
import { PhoneInput } from '../base/PhoneInput';

interface ContactInputProps {
  type: DefaultContactOptionsTypes;
  handleClear: () => void;
  name: string;
  value: string;
  onChange: (value: unknown) => void;
  error: any;
}

const inputTypes = {
  [DefaultContactOptionsTypes.Phone]: {
    placeholder: inputMaskHash.phoneWithBracket,
  },
  [DefaultContactOptionsTypes.Email]: {
    placeholder: 'Введите email',
    icon: <MailOutlined />,
  },
  [DefaultContactOptionsTypes.Site]: {
    placeholder: 'Ссылка на сайт',
    icon: <GlobalOutlined />,
  },
  [DefaultContactOptionsTypes.VK]: {
    placeholder: 'https://vk.com/1',
    icon: <CustomIcon name={SvgIconNames.VK} />,
  },
  [DefaultContactOptionsTypes.OK]: {
    placeholder: 'https://ok.ru/1',
    icon: <CustomIcon name={SvgIconNames.OK} />,
  },
  [DefaultContactOptionsTypes.Telegram]: {
    placeholder: 'https://t.me/1',
    icon: <CustomIcon name={SvgIconNames.Telegram} />,
  },
  [DefaultContactOptionsTypes.YandexDzen]: {
    placeholder: 'https://dzen.ru/1',
    icon: <CustomIcon name={SvgIconNames.YandexDzen} />,
  },
};

export const ContactInput: React.FC<ContactInputProps> = React.forwardRef(
  (
    { type, handleClear, error, ...props },
    ref: React.Ref<InputRef> | React.ForwardedRef<HTMLInputElement>
  ) => (
    <Col md={{ span: 12 }} xs={{ span: 24 }}>
      <Form.Item
        help={error?.message}
        validateStatus={error?.message ? 'error' : 'success'}
        label={defaultContactNames[type]}
      >
        <Row gutter={12} style={{ flexWrap: 'nowrap' }}>
          <Col flex='auto'>
            <>
              {type === DefaultContactOptionsTypes.Phone ? (
                <PhoneInput {...props} ref={ref} error={error} />
              ) : (
                <Input
                  {...props}
                  ref={ref as React.Ref<InputRef>}
                  placeholder={inputTypes[type].placeholder}
                  prefix={inputTypes[type].icon}
                />
              )}
            </>
          </Col>
          <Col>
            <Button icon={<DeleteOutlined />} onClick={handleClear} />
          </Col>
        </Row>
      </Form.Item>
    </Col>
  )
);

ContactInput.displayName = 'ContactInput';
